<template>
    <div class="out-div">
        <div class="card-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- <img src="../assets/newWhsImg/多元升学.png" style="width:100%"/> -->
        <div id="jsmind_container" ref="jsmind_container"></div>
    </div>
</template>
<script>
import "jsmind/style/jsmind.css";
import jsMind from "jsmind";
import {mapState} from "vuex";
export default {
    data(){
        return {
            
            mindData: {


                "meta": {


                "name": "example",


                "author": "author",


                "version": "0.2"


                },


                "format": "node_tree",


                "data": {


                "id": "root",


                "topic": "湖南省多元升学思维导图",


                "children": [


                    { "id": "sub1", "topic": "参加高考，考核高考成绩，填报志愿", "children": [
                        { "id": "sub15", "topic": "本科提前批", "children": [
                        { "id": "sub19", "topic": "平行志愿", "children": [
                            { "id": "sub21", "topic": "军事院校", "children": [] },
                            { "id": "sub22", "topic": "其他院校", "children": [
                                { "id": "sub25", "topic": "国家公费师范生", "children": [] },
                                { "id": "sub26", "topic": "国家公费师范生（国家专项）", "children": [] },
                                { "id": "sub77", "topic": "国家公费师范生（高校专项）", "children": [] },
                                { "id": "sub27", "topic": "国家优师专项", "children": [] },
                                { "id": "sub28", "topic": "省内公费师范生（含优师专项）", "children": [] },
                                { "id": "sub29", "topic": "小语种", "children": [] },
                                { "id": "sub30", "topic": "种子科学与工程", "children": [] },
                                { "id": "sub31", "topic": "马克思主义理论", "children": [] },

                            ] },
                            { "id": "sub23", "topic": "公安院校", "children": [] },
                            { "id": "sub24", "topic": "艺术类专业", "children": [] },
                            
                        ] },
                        { "id": "sub20", "topic": "单个志愿", "children": [
                            { "id": "sub32", "topic": "航海类", "children": [] },
                            { "id": "sub33", "topic": "省外高校综合评价", "children": [] },
                            { "id": "sub34", "topic": "民航飞行员", "children": [] },
                            { "id": "sub35", "topic": "农村订单定向免费医学生", "children": [] },
                            // { "id": "sub36", "topic": "农技特岗生", "children": [] },
                            // { "id": "sub37", "topic": "林业特岗生", "children": [] },
                            // { "id": "sub38", "topic": "水利特岗生", "children": [] },
                            { "id": "sub39", "topic": "核产业特岗生", "children": [] },
                            { "id": "sub40", "topic": "其他院校", "children": [
                                { "id": "sub41", "topic": "需政治考核，体检与面试", "children": [] },
                                { "id": "sub42", "topic": "不需政治考核，体检与面试", "children": [
                                    // {"id":"sub76","topic":"香港中文大学","children":[]}
                                ] },

                            ] },

                        ] },

                        ] },
                        { "id": "sub16", "topic": "普通本科批", "children": [
                            { "id": "sub43", "topic": "特殊类型志愿", "children": [
                                { "id": "sub45", "topic": "高水平运动队", "children": [] },
                                // { "id": "sub46", "topic": "高校专项计划", "children": [] },
                                { "id": "sub47", "topic": "中南大学综合评价录取", "children": [] },

                            ] },
                            { "id": "sub44", "topic": "普通志愿", "children": [
                                { "id": "sub48", "topic": "非定向", "children": [] },
                                { "id": "sub49", "topic": "定向", "children": [] },
                                { "id": "sub50", "topic": "国家专项", "children": [] },
                                { "id": "sub46", "topic": "高校专项", "children": [] },
                                { "id": "sub51", "topic": "地方专项", "children": [] },
                                { "id": "sub52", "topic": "楚怡工匠", "children": [] },
                                { "id": "sub53", "topic": "不组织专业考试的艺术专业", "children": [] },
                                { "id": "sub54", "topic": "民族班", "children": [] },
                                { "id": "sub55", "topic": "预科班", "children": [
                                    { "id": "sub56", "topic": "少数民族预科班", "children": [] },
                                    { "id": "sub57", "topic": "边防军人子女预科班", "children": [] },

                                ] },
                                { "id": "sub58", "topic": "定向西藏就业", "children": [] },
                                
                            ] },

                        ] },
                        { "id": "sub17", "topic": "专科提前批", "children": [
                            { "id": "sub59", "topic": "平行志愿", "children": [
                                { "id": "sub61", "topic": "定向培养军士", "children": [] },

                            ] },
                            { "id": "sub60", "topic": "单个志愿", "children": [
                                { "id": "sub62", "topic": "司法类", "children": [] },
                                { "id": "sub63", "topic": "航空乘务类", "children": [] },
                                { "id": "sub64", "topic": "航海类", "children": [] },
                                // { "id": "sub65", "topic": "基层医疗卫生机构本土化人才培养", "children": [] },
                                // { "id": "sub66", "topic": "农技特岗生", "children": [] },
                                // { "id": "sub67", "topic": "林业特岗生", "children": [] },
                                // { "id": "sub68", "topic": "水利特岗生", "children": [] },
                                { "id": "sub69", "topic": "其他院校（专业）（需面试或签约）", "children": [] },

                            ] },

                        ] },
                        { "id": "sub18", "topic": "高职专科批", "children": [] },

                    ] },


                    { "id": "sub2", "topic": "不参加高考", "children": [
                        { "id": "sub7", "topic": "出国留学", "children": [] },
                        { "id": "sub9", "topic": "保送生", "children": [
                        { "id": "sub12", "topic": "五大学科奥林匹克国家集训队员", "children": [] },
                        { "id": "sub13", "topic": "英烈子女", "children": [] },
                        { "id": "sub14", "topic": "退役运动员", "children": [] },
                        ] },
                        { "id": "sub70", "topic": "体育单招", "children": [] },
                        { "id": "sub10", "topic": "高职单招", "children": [] },
                        { "id": "sub8", "topic": "物理英才班", "children": [] },
                        { "id": "sub11", "topic": "数学英才班", "children": [] },
                    ] },
                    { "id": "sub3", "topic": "参加高考，考核高考成绩", "children": [
                        {"id":"sub72","topic": "不用填报高考志愿","children":[
                            { "id": "sub4", "topic": "强基计划", "children": [] },
                            { "id": "sub5", "topic": "空军招飞", "children": [] },
                            { "id": "sub6", "topic": "海军招飞", "children": [] },
                            { "id": "sub71", "topic": "少年班", "children": [] },
                        ]
                        },
                        {
                            "id":"sub73","topic":"到学校官网申请","children":[
                                {"id":"sub75","topic":"澳门学校","children":[]},
                                {"id":"sub74","topic":"<span>香港学校<span style='background-color:red;padding:10px 0;margin-left:10px;'>（除香港中文大学外）</span></span>","children":[]}
                            ]
                        },
                    ] }


                ]


                }


            },
            mind:{},
            shengxueArr:[]
        }
    },
    methods:{
        mindEventClick(){
            let htmlElement=document.getElementById("jsmind_container");
            const that=this;
            htmlElement.addEventListener("click",function(e){
                if (e.target.localName === 'jmnode') {
                let nodeId = e.target.getAttribute('nodeid');
                const txt=e.target.innerText;
                // 根据nodeId进行openWindow()
                if(nodeId==="sub4"){
                    if(that.userInfo&&that.userInfo.yhid){
                        that.$store.commit('initIsUpdateToken');
                        that.$router.push("/main/qjPlan");
                    }
                }else{
                    const obj=that.findDuoYuanShengXue(that.mindData.data.children,nodeId);
                    if(obj&&obj.topic){
                        if(that.userInfo&&that.userInfo.yhid){
                            that.$store.commit('initIsUpdateToken');
                            that.$router.push("/main/youngban?nodeId="+nodeId+"&&name="+txt);
                        }
                    }
                }
                }
            });
        },
        findDuoYuanShengXue(arr,id){
            const obj=this.findArr(arr,id);
            if(obj.id){
                return obj
            }else{
                for(let i=0;i<arr.length;i++){
                    if(arr[i].children&&arr[i].children.length>0){
                        const obj2=this.findArr(arr[i].children,id);
                        if(obj2.id){
                            return obj2;
                        }else{
                            const arr2=arr[i].children;
                            for(let j=0;j<arr2.length;j++){
                                const obj3=this.findArr(arr2[j].children,id);
                                if(obj3.id){
                                    return obj3;
                                }else{
                                    const arr3=arr2[j].children;
                                    for(let k=0;k<arr3.length;k++){
                                        const obj4=this.findArr(arr3[k].children,id);
                                        if(obj4.id){
                                            return obj4;
                                        }else{
                                            const arr4=arr3[k].children;
                                            for(let l=0;l<arr4.length;l++){
                                                const obj5=this.findArr(arr4[l].children,id);
                                                if(obj5.id){
                                                    return obj5;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        findArr(arr,id){
            let flag=true;
            for(let i=0;i<arr.length;i++){
                if(arr[i].id===id&&arr[i].children.length===0){
                    return arr[i];
                }
            }
            if(flag){
                return {};
            }
        }
    },
    computed:{
        ...mapState(["userInfo"])
    },
    mounted(){
        
        const options = {


        container: 'jsmind_container',

        format: 'node_array',


        editable: false,


        theme: 'primary',

        default_event_type:'click',

        

        shortcut: {
            enable: true,
        },

        context_menu:{
            enable: true,
        }

        };
        const mind = jsMind.show(options);
        mind.show(this.mindData);
        this.mind=mind;
        mind.enable_edit();
        console.log(mind.set_node_color);
        mind.set_node_color('sub18','red','');
        mind.set_node_color('sub48','red','');
        mind.disable_edit();
        this.mindEventClick();
    }
}
</script>
<style scoped lang="less">
.out-div{
    width: 100%;
#jsmind_container {


//   width: 100%;
  width: 100%;


  height: 1000px;


//   border: 1px solid #ccc;


}
.card-top{
        width: 1100px;
        margin: 20px auto;
}
}

jmnodes.theme-greensea jmnode{background-color:#1abc9c;color:#fff;}  
</style>